import React, { useState, useRef } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import axios from 'axios';

export default function ObjetTrouve(props) {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        title: '',
        category: '',
        location: '',
        latitude: '',
        longitude: '',
        dateFound: new Date().toISOString().slice(0, 16),
        description: '',
        creation: new Date().toISOString().slice(0, 16),
    });
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [imageFile, setImageFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const cropperRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    const categories = [
        { id: 'Valeurs', label: 'Portefeuille', icon: 'wallet', desc: 'Cartes, espèces' },
        { id: 'Clés', label: 'Clés', icon: 'key', desc: 'Maison, voiture' },
        { id: 'Electronique', label: 'Électronique', icon: 'smartphone', desc: 'Téléphone, PC' },
        { id: 'Documents', label: 'Documents', icon: 'description', desc: ', Passeport' },
        { id: 'CNI', label: 'CNI', icon: 'badge', desc: 'Carte nationale d\'identité' },
        { id: 'Passeport', label: 'Passeport', icon: 'book', desc: 'Document de voyage' },
        { id: 'Permis de conduire', label: 'Permis', icon: 'drive_eta', desc: 'Permis de conduire' },
        { id: 'Autre', label: 'Autre', icon: 'category', desc: 'Objet divers' },
    ];


    const validateField = (name, value) => {
        if (['title', 'location', 'description'].includes(name)) {
            if (value && value.trim().length > 0 && value.trim().length < 3) {
                return 'Ce champ doit contenir au moins 3 caractères.';
            }
        }
        return null;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (touched[name]) {
            setErrors(prev => ({ ...prev, [name]: validateField(name, value) }));
        }
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;
        setTouched(prev => ({ ...prev, [name]: true }));
        setErrors(prev => ({ ...prev, [name]: validateField(name, value) }));
    };

    const handleCategorySelect = (categoryId) => {
        setFormData(prev => ({ ...prev, category: categoryId }));
    };


    const handleImageChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            setImageFile(file);
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                setPreviewUrl(reader.result);
            };
        }
    };

    const clearImage = () => {
        setImageFile(null);
        setPreviewUrl(null);
    };

    const scrollToForm = () => {
        const formElement = document.getElementById('report-found-object-form');
        if (formElement) {
            const y = formElement.getBoundingClientRect().top + window.scrollY - 100;
            window.scrollTo({ top: y, behavior: 'smooth' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleNext = () => {
        setStep(prev => Math.min(prev + 1, 3));
        setTimeout(scrollToForm, 100);
    };

    const handlePrev = () => {
        setStep(prev => Math.max(prev - 1, 1));
        setTimeout(scrollToForm, 100);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        const data = new FormData();
        const requestData = { ...formData };

        Object.keys(requestData).forEach(key => data.append(key, requestData[key]));

        if (cropperRef.current && cropperRef.current.cropper) {
            const canvas = cropperRef.current.cropper.getCroppedCanvas({
                width: 512,
                height: 512
            });
            if (canvas) {
                const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.9));
                data.append('imageFile', blob, imageFile ? imageFile.name : 'cropped.jpg');
            } else if (imageFile) {
                data.append('imageFile', imageFile);
            }
        } else if (imageFile) {
            data.append('imageFile', imageFile);
        }

        try {
            const response = await axios.post(props.submitUrl, data);

            const result = response.data;
            if (result.success) {
                setSuccess(true);
                setTimeout(() => {
                    window.location.href = props.redirectUrl;
                }, 2000);
            } else {
                setError(result.error || 'Une erreur est survenue');
            }
        } catch (err) {
            setError('Erreur de connexion au serveur');
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="card border-0 shadow-lg text-center p-5 mx-auto" style={{ maxWidth: '600px', borderRadius: '20px' }}>
                <div className="card-body py-5">
                    <div className="d-flex align-items-center justify-content-center mx-auto mb-4 bg-light rounded-circle" style={{ width: '80px', height: '80px', color: 'var(--vert-senegal)' }}>
                        <i className="fas fa-check-circle" style={{ fontSize: '3rem' }}></i>
                    </div>
                    <h2 className="font-weight-bold mb-3" style={{ color: 'var(--gris-fonce)' }}>Signalement Publié !</h2>
                    <p className="text-muted lead mb-0">Merci de votre aide. Vous allez être redirigé vers votre tableau de bord...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="container py-4">
            <div className="row justify-content-center">
                <div className="col-lg-12">
                    <div className="text-center mb-5 fade-in visible">
                        <p className="text-muted lead">Aidez la communauté en signalant un objet que vous avez récupéré.</p>
                    </div>

                    <div id="report-found-object-form" className="card border-0 shadow-sm fade-in visible" style={{ borderRadius: '20px', overflow: 'hidden' }}>
                        <div className="card-header bg-white border-bottom-0 pt-4 pb-3 px-4 px-md-5">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="font-weight-bold mb-0 text-muted text-uppercase" style={{ letterSpacing: '1px' }}>Progression</h6>
                                <span className="font-weight-bold" style={{ color: 'var(--vert-senegal)' }}>Étape {step} sur 3</span>
                            </div>
                            <div className="progress" style={{ height: '8px', borderRadius: '10px' }}>
                                <div className="progress-bar" role="progressbar" style={{ width: `${(step / 3) * 100}%`, backgroundColor: 'var(--vert-senegal)' }} aria-valuenow={(step / 3) * 100} aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>

                        {error && (
                            <div className="alert alert-danger mx-4 mx-md-5 mt-3 d-flex align-items-center" role="alert" style={{ borderRadius: '10px' }}>
                                <i className="fas fa-exclamation-circle mr-2"></i> {error}
                            </div>
                        )}

                        <div className="card-body p-4 p-md-5">
                            <div className="alert alert-light py-2 px-3 mb-4 d-flex align-items-center" style={{ borderRadius: '12px', background: '#f8f9fb', border: '1px solid #e8eaf0' }}>
                                <i className="fas fa-info-circle text-primary mr-2 small"></i>
                                <span className="small font-weight-bold text-muted">Tous les champs marqués d'une astérisque (*) sont obligatoires.</span>
                            </div>
                            {/* Step 1 */}
                            {step === 1 && (
                                <div className="step-content">
                                    <div className="mb-4">
                                        <h3 className="font-weight-bold h4 mb-2" style={{ color: 'var(--gris-fonce)' }}>Étape 1: Que contient l'objet ? <span className="text-danger">*</span></h3>
                                        <p className="text-muted small">Sélectionnez la catégorie qui correspond le mieux.</p>
                                    </div>

                                    <div className="row mb-4">
                                        {categories.map(cat => (
                                            <div key={cat.id} className="col-6 col-md-3 mb-3">
                                                <div
                                                    onClick={() => handleCategorySelect(cat.id)}
                                                    className={`card h-100 text-center cursor-pointer transition-all ${formData.category === cat.id ? 'border-primary' : 'border-light'}`}
                                                    style={{
                                                        borderRadius: '15px',
                                                        border: `2px solid ${formData.category === cat.id ? 'var(--vert-senegal)' : '#f8f9fa'}`,
                                                        backgroundColor: formData.category === cat.id ? 'rgba(13, 127, 242, 0.05)' : 'white',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    <div className="card-body p-3">
                                                        <span className="material-symbols-outlined mb-2" style={{ fontSize: '2rem', color: formData.category === cat.id ? 'var(--vert-senegal)' : '#adb5bd' }}>{cat.icon}</span>
                                                        <h6 className="font-weight-bold mb-1" style={{ fontSize: '0.9rem' }}>{cat.label}</h6>
                                                        <p className="text-muted small mb-0" style={{ fontSize: '0.7rem' }}>{cat.desc}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    {formData.category === 'Autre' && (
                                        <div className="alert alert-info border-0 mb-4" style={{ borderRadius: '10px', backgroundColor: 'rgba(13, 127, 242, 0.1)', color: 'var(--vert-senegal)' }}>
                                            <i className="fas fa-info-circle mr-2"></i> <strong>Astuce :</strong> Indiquez le type d'objet directement dans le titre ci-dessous.
                                        </div>
                                    )}


                                    <div className="form-group mb-5">
                                        <label className="font-weight-bold">Titre ou Nom de l'objet <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            name="title"
                                            value={formData.title}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Ex: iPhone 13 Pro noir..."
                                            className={`form-control form-control-lg ${errors.title ? 'is-invalid' : ''}`}
                                            style={{ borderRadius: '10px', padding: '15px 20px', fontSize: '1rem', backgroundColor: '#f8f9fa', border: 'none' }}
                                        />
                                        {errors.title ? (
                                            <div className="invalid-feedback font-weight-bold">{errors.title}</div>
                                        ) : (
                                            <small className="form-text text-muted mt-2"><i className="fas fa-info-circle mr-1"></i>Soyez précis pour faciliter la recherche (ex: marque, modèle).</small>
                                        )}
                                    </div>

                                    <div className="d-flex justify-content-end pt-3 border-top">
                                        <button
                                            type="button"
                                            onClick={handleNext}
                                            disabled={!formData.category || !formData.title || formData.title.trim().length < 3 || !!errors.title || (formData.category === 'Documents' && !formData.documentType)}
                                            className="btn px-5 py-3 font-weight-bold text-white transition-all"
                                            style={{ borderRadius: '10px', background: 'var(--vert-senegal)' }}
                                        >
                                            Continuer <i className="fas fa-arrow-right ml-2"></i>
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Step 2 */}
                            {step === 2 && (
                                <div className="step-content">
                                    <div className="mb-4">
                                        <h3 className="font-weight-bold h4 mb-2" style={{ color: 'var(--gris-fonce)' }}>Étape 2: Où et quand l'avez-vous trouvé ?</h3>
                                        <p className="text-muted small">Précisez le lieu exact pour faciliter l'identification par le propriétaire.</p>
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-6 mb-4">
                                            <div className="form-group">
                                                <label className="font-weight-bold">Localisation <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    name="location"
                                                    value={formData.location}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="Ex: Plateau, Dakar"
                                                    className={`form-control form-control-lg ${errors.location ? 'is-invalid' : ''}`}
                                                    style={{ borderRadius: '10px', padding: '15px 20px', fontSize: '1rem', backgroundColor: '#f8f9fa', border: 'none' }}
                                                />
                                                {errors.location ? (
                                                    <div className="invalid-feedback font-weight-bold">{errors.location}</div>
                                                ) : (
                                                    <small className="form-text text-muted mt-2">Nom du quartier, rue ou point de repère.</small>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-4">
                                            <div className="form-group">
                                                <label className="font-weight-bold">Date et Heure <span className="text-danger">*</span></label>
                                                <input
                                                    type="datetime-local"
                                                    name="dateFound"
                                                    value={formData.dateFound}
                                                    onChange={handleChange}
                                                    className="form-control form-control-lg"
                                                    style={{ borderRadius: '10px', padding: '15px 20px', fontSize: '1rem', backgroundColor: '#f8f9fa', border: 'none' }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mb-5">
                                        <div className="col-md-6 mb-3">
                                            <div className="form-group">
                                                <label className="font-weight-bold">Latitude <span className="text-muted font-weight-normal small">(Optionnel)</span></label>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    name="latitude"
                                                    value={formData.latitude}
                                                    onChange={handleChange}
                                                    placeholder="Ex: 14.6928"
                                                    className="form-control form-control-lg text-monospace"
                                                    style={{ borderRadius: '10px', padding: '15px 20px', fontSize: '1rem', backgroundColor: '#f8f9fa', border: 'none' }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <div className="form-group">
                                                <label className="font-weight-bold">Longitude <span className="text-muted font-weight-normal small">(Optionnel)</span></label>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    name="longitude"
                                                    value={formData.longitude}
                                                    onChange={handleChange}
                                                    placeholder="Ex: -17.4467"
                                                    className="form-control form-control-lg text-monospace"
                                                    style={{ borderRadius: '10px', padding: '15px 20px', fontSize: '1rem', backgroundColor: '#f8f9fa', border: 'none' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between pt-3 border-top">
                                        <button type="button" onClick={handlePrev} className="btn btn-light px-4 py-3 font-weight-bold" style={{ borderRadius: '10px' }}>
                                            <i className="fas fa-arrow-left mr-2"></i> Retour
                                        </button>
                                        <button
                                            type="button"
                                            onClick={handleNext}
                                            disabled={!formData.location || formData.location.trim().length < 3 || !!errors.location || !formData.dateFound}
                                            className="btn px-5 py-3 font-weight-bold text-white transition-all"
                                            style={{ borderRadius: '10px', background: 'var(--vert-senegal)' }}
                                        >
                                            Continuer <i className="fas fa-arrow-right ml-2"></i>
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* Step 3 */}
                            {step === 3 && (
                                <div className="step-content">
                                    <div className="mb-4">
                                        <h3 className="font-weight-bold h4 mb-2" style={{ color: 'var(--gris-fonce)' }}>Étape 3: Description & Photo</h3>
                                        <p className="text-muted small">Ajoutez une photo claire pour certifier l'objet trouvé.</p>
                                    </div>

                                    <div className="form-group mb-4">
                                        <label className="font-weight-bold">Description <span className="text-muted font-weight-normal small">(Optionnel)</span></label>
                                        <textarea
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            rows="4"
                                            className={`form-control form-control-lg ${errors.description ? 'is-invalid' : ''}`}
                                            placeholder="Détails supplémentaires..."
                                            style={{ borderRadius: '10px', padding: '15px 20px', fontSize: '1rem', backgroundColor: '#f8f9fa', border: 'none', resize: 'none' }}
                                        ></textarea>
                                        {errors.description ? (
                                            <div className="invalid-feedback font-weight-bold">{errors.description}</div>
                                        ) : (
                                            <small className="form-text text-muted mt-2">Ajoutez tout détail utile (couleur, signes particuliers) sans trop en dire.</small>
                                        )}
                                    </div>

                                    <div className="form-group mb-5">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <label className="font-weight-bold mb-0">Photo <span className="text-danger">*</span></label>
                                            {previewUrl && (
                                                <button onClick={clearImage} type="button" className="btn btn-sm btn-link text-danger font-weight-bold p-0 text-decoration-none">
                                                    <i className="fas fa-trash-alt mr-1"></i> Supprimer
                                                </button>
                                            )}
                                        </div>

                                        {!previewUrl ? (
                                            <div className="position-relative d-flex flex-column align-items-center justify-content-center bg-light rounded" style={{ height: '200px', border: '2px dashed #ced4da', cursor: 'pointer', borderRadius: '15px' }}>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={handleImageChange}
                                                    className="position-absolute w-100 h-100"
                                                    style={{ opacity: 0, cursor: 'pointer', zIndex: 10 }}
                                                />
                                                <i className="fas fa-cloud-upload-alt text-muted mb-3" style={{ fontSize: '3rem' }}></i>
                                                <p className="font-weight-bold text-muted mb-0">Cliquez pour ajouter une photo</p>
                                            </div>
                                        ) : (
                                            <div className="bg-dark rounded overflow-hidden shadow-sm" style={{ border: '1px solid #ced4da', borderRadius: '15px' }}>
                                                <Cropper
                                                    src={previewUrl}
                                                    style={{ height: 350, width: "100%" }}
                                                    aspectRatio={285 / 180}
                                                    guides={true}
                                                    ref={cropperRef}
                                                    viewMode={1}
                                                    dragMode="move"
                                                    minCropBoxHeight={100}
                                                    minCropBoxWidth={100}
                                                    background={false}
                                                    responsive={true}
                                                    autoCropArea={0.8}
                                                    checkOrientation={false}
                                                />
                                            </div>
                                        )}
                                        <small className="form-text text-muted text-center mt-3"><i className="fas fa-info-circle mr-1"></i> Une photo claire de l'objet est obligatoire. Recadrez-la si nécessaire.</small>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center pt-3 border-top">
                                        <button type="button" onClick={handlePrev} className="btn btn-light px-4 py-3 font-weight-bold" style={{ borderRadius: '10px' }}>
                                            <i className="fas fa-arrow-left mr-2"></i> Retour
                                        </button>
                                        <button
                                            type="button"
                                            onClick={handleSubmit}
                                            disabled={loading || !imageFile || !!errors.description || (formData.description && formData.description.trim().length < 3)}
                                            className="btn px-5 py-3 font-weight-bold text-white shadow-sm d-flex align-items-center"
                                            style={{ borderRadius: '10px', background: 'var(--vert-senegal)' }}
                                        >
                                            {loading ? (
                                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                            ) : (
                                                <i className="fas fa-paper-plane mr-2"></i>
                                            )}
                                            Publier le signalement
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
